import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

export function GlossaryText({ text, glossary }) {
  if (!text) return null;
  if (!glossary || glossary.length === 0) return <span>{text}</span>;
  const terms = glossary.slice().sort((a, b) => b.kavram.length - a.kavram.length);
  const escaped = terms.map((t) => t.kavram.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  let re;
  try {
    re = new RegExp(`(?<![\\p{L}\\p{N}])(${escaped.join("|")})(?![\\p{L}\\p{N}])`, "giu");
  } catch (e) {
    re = new RegExp(`(${escaped.join("|")})`, "gi");
  }
  const parts = text.split(re);
  return (
    <span>
      {parts.map((part, i) => {
        const match = terms.find((t) => t.kavram.toLowerCase() === (part || "").toLowerCase());
        if (match) {
          return (
            <HoverCard key={i} openDelay={80} closeDelay={40}>
              <HoverCardTrigger asChild>
                <span className="glossary-term" data-testid="glossary-term">{part}</span>
              </HoverCardTrigger>
              <HoverCardContent className="w-72 bg-ink text-page border-ink shadow-xl">
                <p className="font-serif text-lg text-gold">{match.kavram}</p>
                <p className="text-sm mt-1 text-page/80 leading-relaxed">{match.tanim}</p>
              </HoverCardContent>
            </HoverCard>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </span>
  );
}
